import React from 'react'
import { TypeAnimation } from 'react-type-animation'
import logo from './images/logo.svg';

import Lines from './parts/Lines';

export default function Lead({goToSlide}){
   return (
     <>
       <div id="lead" className="row lead">
           <img src={logo} className="portfolio-logo" alt="logo" />
           <TypeAnimation
             sequence={[
               '{ Back-end Developer }', // Types 'One'
               1000, // Waits 1s
               '{ Front-end Developer }', // Deletes 'One' and types 'Two'
               2000, // Waits 2s
               '{ Designer }', // Types 'Three' without deleting 'Two'
               2000,
               () => {}
             ]}
             wrapper="div"
             className="typed-code-animation"
             cursor={true}
             repeat={Infinity}
           />
           <a href="#" className="go-down" onClick={() => goToSlide(1)}></a>
      </div>
      <Lines></Lines>
    </>
  );
}
